import { ICity } from 'contexts/searchParams';
import { createContext } from 'react';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const SelectAirportContext = createContext((airport: ICity) => {});

export { SelectAirportContext };
